import type { BundleFloorLevel } from '../../../schemas/apiResponse.schemas';
import { BundleFloorLevelSchema } from '../../../schemas/apiResponse.schemas';
import { parseOrderDetailNavState } from './orderDetailNavState';

export const DEFAULT_BUNDLE_WORK_FROM_PATH = '/bundle-work-orders';

export interface BundleWorkNavState {
  readonly fromPath: string;
  readonly siblingOrderIds: readonly string[];
  readonly floorEntry?: BundleFloorLevel;
}

function parseFloorEntry(state: Record<string, unknown>): BundleFloorLevel | undefined {
  const raw = state.floorEntry;
  if (!raw || typeof raw !== 'object') {
    return undefined;
  }
  const parsed = BundleFloorLevelSchema.safeParse(raw);
  return parsed.success ? parsed.data : undefined;
}

export function parseBundleWorkNavState(state: unknown): BundleWorkNavState {
  const base = parseOrderDetailNavState(state);
  const fromPath =
    typeof base.fromPath === 'string' && base.fromPath.startsWith('/')
      ? base.fromPath
      : DEFAULT_BUNDLE_WORK_FROM_PATH;
  const siblingOrderIds = base.siblingOrderIds.map((id) => String(id));

  if (!state || typeof state !== 'object') {
    return { fromPath, siblingOrderIds };
  }

  return {
    fromPath,
    siblingOrderIds,
    floorEntry: parseFloorEntry(state as Record<string, unknown>),
  };
}

export function findBundleWorkSiblingIndex(
  siblingSkus: readonly string[],
  parentSku: string,
): number {
  return siblingSkus.findIndex((sku) => String(sku) === String(parentSku));
}
